// extracted by css-extract-rspack-plugin
export default {"TextInput_Action":"CodeNavSymbolNavigation-module__TextInput_Action__vnti3rA"};